<template>
  <v-container fill-height class="wider">
    <div class="d-flex" style="justify-content: space-between; width: 100%; align-items: center;">
      <div class="d-flex" style="justify-content: space-between; align-items: center; gap: 10px">
        <v-btn class="primary" @click="back()">&lt;</v-btn>
        <v-text-field v-model="overlay.name" class="namefield" autocomplete="off"></v-text-field>
      </div>
      <v-btn class="primary" @click="save">Speichern</v-btn>
    </div>
    <v-row no-gutters class="fill-most">
      <v-col cols="3" style="background-color: #1E1E1E">
        <OverlayListComponent
          :layers="overlay.layers"
          v-if="overlay.layers"
          ref="overlayList"
          @activate-layer="activateLayer"
          @update-layer="updateLayer"
          @delete-layer="deleteLayer"
        />
      </v-col>
      <v-col cols="9">
        <OverlayComponent
          v-if="overlay.id"
          :width="overlay.width"
          :height="overlay.height"
          :edit="true"
          :layers="overlay.layers"
          @addLayer="addLayer"
          @update-layer="updateLayer"
          @activate-layer="activateLayer"
          @deactivate-layer="deactivateLayer"
          />
      </v-col>
    </v-row>
    <!-- Snackbar für Erfolgsmeldung -->
    <v-snackbar v-model="snackbar" color="success" timeout="3000" top>
      <span>Speichern erfolgreich!</span>
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Schließen
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>
<script>

import BackendService from '@/services/BackendService';
import OverlayComponent from '@/components/OverlayComponent.vue';
import OverlayListComponent from '@/components/OverlayListComponent.vue';
import deepMerge from '@/utils/deepMerge';

export default {
  name: 'OverlayEditComponent',
  components: { OverlayComponent, OverlayListComponent },
  data: () => ({
    overlay: {},
    originalOverlay: {},
    snackbar: false,
  }),
  mounted() {
    BackendService.loadOverlay(this.$router.currentRoute.params.id).then((data) => {
      this.overlay = data.data;
      this.originalOverlay = JSON.parse(JSON.stringify(this.overlay));
    });
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasUnsavedChanges()) {
      // eslint-disable-next-line no-restricted-globals
      if (confirm('You have unsaved changes. Are you sure you want to leave?')) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  methods: {
    activateLayer(index) {
      if (index !== null) {
        for (let i = 0; i < this.overlay.layers.length; i += 1) {
          if (i !== index) {
            this.overlay.layers[i].active = false;
          }
        }
      }

      this.overlay.layers[index].active = true;
      this.$refs.overlayList.setActive(index);
    },
    deactivateLayer(index) {
      this.overlay.layers[index].active = false;
      if (this.overlay.layers.filter((item) => item.active === true) === 0) {
        this.$refs.overlayList.setActive(null);
      }
    },
    addLayer(type) {
      let name = type;
      const originalName = type;
      let counter = 0;
      const findName = ((item) => item.name === name);
      while (this.overlay.layers.find(findName)) {
        counter += 1;
        name = `${originalName} ${counter}`;
      }

      const layerData = {
        type, width: 200, height: 200, x: 0, y: 0, active: false, name, rotation: 0, opacity: 100,
      };

      if (type === 'title') {
        layerData.value = name;
        layerData.font = 'Roboto';
        layerData.color = '#FFFFFF';
        layerData.fontSize = 20;
        layerData.lineHeight = 1.5;
        layerData.alignment = 'left';
        layerData.bold = false;
        layerData.italic = false;
        layerData.underline = false;
        layerData.shadow = false;
        layerData.shadowStyle = 'rgb(0, 0, 0) 1px 1px 1px';
        layerData.animation = 'none';
      }

      if (type === 'alertbox') {
        layerData.alerts = [];
      }

      this.overlay.layers.push(layerData);
    },
    back() {
      if (this.hasUnsavedChanges()) {
        // eslint-disable-next-line no-restricted-globals
        if (confirm('You have unsaved changes. Are you sure you want to leave?')) {
          this.$router.push({ name: 'overlay' });
        }
      } else {
        this.$router.push({ name: 'overlay' });
      }
    },
    updateLayer(event) {
      // console.log(event.index);
      this.overlay.layers[event.index].x = parseInt(event.data.x, 10);
      this.overlay.layers[event.index].y = parseInt(event.data.y, 10);
      this.overlay.layers[event.index].height = parseInt(event.data.height, 10);
      this.overlay.layers[event.index].width = parseInt(event.data.width, 10);
      this.overlay.layers[event.index].rotation = parseInt(event.data.rotation, 10);
      this.overlay.layers[event.index].opacity = parseInt(event.data.opacity, 10);

      this.overlay.layers[event.index].name = event.data.name;

      if (this.overlay.layers[event.index].type === 'title') {
        this.overlay.layers[event.index].font = event.data.font;
        this.overlay.layers[event.index].color = event.data.color;
        this.overlay.layers[event.index].value = event.data.value;
        this.overlay.layers[event.index].fontSize = event.data.fontSize;
        this.overlay.layers[event.index].lineHeight = event.data.lineHeight;
        this.overlay.layers[event.index].alignment = event.data.alignment;
        this.overlay.layers[event.index].bold = event.data.bold;
        this.overlay.layers[event.index].italic = event.data.italic;
        this.overlay.layers[event.index].underline = event.data.underline;
        this.overlay.layers[event.index].shadow = event.data.shadow;
        this.overlay.layers[event.index].shadowStyle = event.data.shadowStyle;
        this.overlay.layers[event.index].animation = event.data.animation;
      } else if (this.overlay.layers[event.index].type === 'alertbox') {
        this.overlay.layers[event.index].alerts = event.data.alerts;
      }

      if (event.source === 'layer') {
        this.$refs.overlayList.refreshActiveLayer();
      }
    },
    save() {
      BackendService.saveOverlay(this.getOverlayData()).then((data) => {
        deepMerge(this.overlay, data.data);
        this.snackbar = true;
        this.originalOverlay = JSON.parse(JSON.stringify(this.overlay));
        this.$refs.overlayList.refreshActiveLayer();
      });
    },
    deleteLayer(index) {
      BackendService.deleteLayer({ overlay: this.overlay.id, layer: this.overlay.layers[index].id }).then(() => {
        this.overlay.layers.splice(index, 1);
        this.$refs.overlayList.refreshActiveLayer();
      });
    },
    getOverlayData() {
      return {
        id: this.overlay.id,
        name: this.overlay.name,
        layers: this.overlay.layers,
      };
    },
    hasUnsavedChanges() {
      // console.log(JSON.stringify(this.overlay));
      // console.log(JSON.stringify(this.originalOverlay));
      return JSON.stringify(this.overlay) !== JSON.stringify(this.originalOverlay);
    },
    handleBeforeUnload(event) {
      if (this.hasUnsavedChanges()) {
        event.preventDefault();
      }
    },
  },
};
</script>
<style scoped lang="scss">
.fill-most {
  height: calc(100% - 50px)
}

.wider {
  max-width: 99vw !important;
}

.namefield {
  max-width: 400px;
}

.namefield::v-deep input {
  font-size: 1.5em !important;
  max-height: 1.5em !important;
  line-height: 1.5em !important;
}

</style>
